import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { func, string, bool } from 'prop-types'
import { useTranslation } from 'react-i18next'
import ModalWindow from '../ModalWindow'
import { scoreRange } from '../../../constants/formData'
import Text from '../Text'
import DateInput from '../DateInput'

import Dropdown from '../Dropdown'
import { VERMILION, METAL, TEXT_BIG } from '../../../constants'

const Grid = styled.div`
  display: grid;
  grid-gap: 10px;
`
const Line = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const FilterCheckboxContainer = styled.div`
  display: grid;
  column-gap: 10px;
  row-gap: 10px;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
  grid-template-columns: 33% 33% 33%;
`
const FilterDateContainer = styled.div`
  display: grid;
  column-gap: 20px;
  row-gap: 10px;
  align-items: center;

  grid-template-columns: auto auto;
`

const AuditFilteringDialog = ({
  onClose,
  onSave,
  visible,
  filterQuery,
  setFilterQuery,
}) => {
  const { t } = useTranslation()
  const [tempFilter, setTempFilter] = useState({
    fromDate: '',
    toDate: '',
    scoreFrom: 0,
    scoreTo: 100,
    successFilter: false,
    failFilter: false,
    progressFilter: false,
    recalculatingFilter: false,
    recalculationFailedFilter: false,
  })

  useEffect(
    () => {
      if (visible) {
        setTempFilter(filterQuery)
      }
    },
    [visible]
  )

  const handleCancel = () => {
    setTempFilter(filterQuery)
    onClose()
  }
  const handleFilter = () => {
    setFilterQuery(tempFilter)
    onSave()
  }

  const resetFilters = () => {
    setFilterQuery(prevState => ({
      ...prevState,
      fromDate: '',
      toDate: '',
      scoreFrom: 0,
      scoreTo: 100,
      successFilter: false,
      failFilter: false,
      progressFilter: false,
      recalculatingFilter: false,
      recalculationFailedFilter: false,
    }))
    setTempFilter(prevState => ({
      ...prevState,
      fromDate: '',
      toDate: '',
      scoreFrom: 0,
      scoreTo: 100,
      successFilter: false,
      failFilter: false,
      progressFilter: false,
      recalculatingFilter: false,
      recalculationFailedFilter: false,
    }))
    onClose()
  }

  const handleDateChange = e => {
    setTempFilter({
      ...tempFilter,
      [e.target.name]: e.target.value,
    })
  }
  return (
    <ModalWindow
      minWidth={'40%'}
      setWidth={'50%'}
      okText={t('filter_audit')}
      onCancel={handleCancel}
      onOk={handleFilter}
      title={t('feed_audit_filter_dialog_title')}
      visible={visible}
      onReset={resetFilters}
      resestText={t('reset-filters')}
    >
      <Grid>
        <Text size={TEXT_BIG} color={METAL}>
          {t('score-filter')}
        </Text>
        <Line>
          <Dropdown
            onChange={e =>
              setTempFilter({
                ...tempFilter,
                scoreFrom: e.from,
                scoreTo: e.to,
              })
            }
            label={t('score-range')}
            dataId="score-range"
            name="score-range"
            options={scoreRange}
            boundValue={scoreRange.find(
              x => x.from == tempFilter.scoreFrom && x.to == tempFilter.scoreTo
            )}
            placeholder={t('select')}
          />
        </Line>
        <span />
        <Text size={TEXT_BIG} color={METAL}>
          {t('date-filter')}
        </Text>
        <FilterDateContainer>
          <DateInput
            name="fromDate"
            type="date"
            label={t('from-date')}
            onChange={handleDateChange}
            value={tempFilter.fromDate}
            setWidth={'-webkit-fill-available'}
          />
          <DateInput
            name="toDate"
            type="date"
            label={t('to-date')}
            onChange={handleDateChange}
            value={tempFilter.toDate}
            setWidth={'-webkit-fill-available'}
          />
        </FilterDateContainer>
        <span />
        <Text size={TEXT_BIG} color={METAL}>
          {t('Status')}
        </Text>
        <FilterCheckboxContainer>
          <label>
            <input
              type="checkbox"
              name="successFilter"
              color={VERMILION}
              checked={tempFilter.successFilter}
              style={{ marginRight: 10 }}
              onChange={e =>
                setTempFilter({
                  ...tempFilter,
                  successFilter: !tempFilter.successFilter,
                })
              }
            />
            {t('audit_success')}
          </label>
          <label>
            <input
              type="checkbox"
              name="failFilter"
              color={VERMILION}
              checked={tempFilter.failFilter}
              style={{ marginRight: 10 }}
              onChange={e =>
                setTempFilter({
                  ...tempFilter,
                  failFilter: !tempFilter.failFilter,
                })
              }
            />
            {t('audit_failed')}
          </label>
          <label>
            <input
              type="checkbox"
              name="progressFilter"
              color={VERMILION}
              checked={tempFilter.progressFilter}
              style={{ marginRight: 10 }}
              onChange={e =>
                setTempFilter({
                  ...tempFilter,
                  progressFilter: !tempFilter.progressFilter,
                })
              }
            />
            {t('audit_progress')}
          </label>
          <label>
            <input
              type="checkbox"
              name="recalculatingFilter"
              color={VERMILION}
              checked={tempFilter.recalculatingFilter}
              style={{ marginRight: 10 }}
              onChange={e =>
                setTempFilter({
                  ...tempFilter,
                  recalculatingFilter: !tempFilter.recalculatingFilter,
                })
              }
            />
            {t('audit_recalculating')}
          </label>
          <label>
            <input
              type="checkbox"
              name="recalculationFailedFilter"
              color={VERMILION}
              checked={tempFilter.recalculationFailedFilter}
              style={{ marginRight: 10 }}
              onChange={e =>
                setTempFilter({
                  ...tempFilter,
                  recalculationFailedFilter: !tempFilter.recalculationFailedFilter,
                })
              }
            />
            {t('audit_recalculationFailed')}
          </label>
        </FilterCheckboxContainer>
        <span />
      </Grid>
    </ModalWindow>
  )
}

AuditFilteringDialog.propTypes = {
  onCancel: func.isRequired,
  onSave: func.isRequired,
  visible: bool.isRequired,
  enableTypeSelection: bool,
  type: string,
  isAdmin: bool,
}

export default AuditFilteringDialog
